import { render, staticRenderFns } from "./AddSales.vue?vue&type=template&id=64f62712"
import script from "./AddSales.vue?vue&type=script&lang=js"
export * from "./AddSales.vue?vue&type=script&lang=js"
import style0 from "./AddSales.vue?vue&type=style&index=0&id=64f62712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports